<template>
  <v-autocomplete
    v-bind="{ ...$props, ...$attrs }"
    class="document-type-select"
    :items="fieldTypeOptions"
    :rules="rules"
    item-value="value"
    @update:model-value="value => $emit('input', value)"
    :label="translatedLabel">
    <template v-slot:item="{ item, props }">
      <v-list-item v-bind="props" :title="null">
        <template #prepend>
          <v-icon>mdi-{{ item.raw.icon }}</v-icon>
        </template>
        <v-list-item-title>
          <span class="font-size-medium">{{ item.raw.text }}</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ item.raw.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-icon size="small" class="mr-2">mdi-{{ item.raw.icon }}</v-icon>
      {{ item.raw.text }}
    </template>
  </v-autocomplete>
</template>
<script>
import { getTranslatedCustomFieldDescriptions, getTranslatedCustomFieldLabels } from '@nova/core';

export default {
  data() {
    return {
      fieldTypeOptions: []
    };
  },
  props: {
    label: {
      type: String,
      required: false
    },
    rules: {
      type: Array,
      required: false
    }
  },
  computed: {
    translatedLabel() {
      return this.label ?? this.$t('customForms.labels.fieldType');
    },
    translatedCustomFieldLabels() {
      return getTranslatedCustomFieldLabels();
    },
    translatedCustomFieldDescriptions() {
      return getTranslatedCustomFieldDescriptions();
    }
  },
  methods: {
    setOptions() {
      this.fieldTypeOptions = Object.entries(this.translatedCustomFieldLabels)
        .filter(field => field[0] !== this.novaCore.CustomFieldType.Action)
        .map(field => ({
          value: field[0],
          text: field[1],
          icon: this.novaCore.customFieldIcons[field[0]],
          description: this.translatedCustomFieldDescriptions[field[0]]
        }));
    }
  },
  beforeMount() {
    this.setOptions();
  }
};
</script>
